import { useQuery, useQueryClient } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { QueryKeys } from '../../querys/querys.enum';
import { AutomationJobStatus, JobListResponse } from '../../../models/Interface/Automation.interface';

const fetchJobs = async (): Promise<JobListResponse> => {
  const response = await automateAxios.get<JobListResponse>('/jobs');
  return response.data;
};

const useJobs = () => {
  const query = useQuery<JobListResponse>({
    queryKey: [QueryKeys.AUTOMATION_JOBS],
    queryFn: fetchJobs,
    refetchInterval: (query) => {
      const hasActive = query.state.data?.jobs.some(
        (j) =>
          j.status === AutomationJobStatus.PENDING ||
          j.status === AutomationJobStatus.PROCESSING
      );
      return hasActive ? 3000 : false;
    },
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  return query;
};

export const useInvalidateJobs = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: [QueryKeys.AUTOMATION_JOBS] });
};

export default useJobs;
